"use client";

import { Box, RadioGroup, FormControlLabel, Radio, Typography } from "@mui/material";
import React, { useState } from "react";
import { fetchWithAuth } from "@/lib/firebase/authInterceptor";
import { MemeVisibility } from "@/types/meme";
import { Button } from "./UI";

interface VisibilityGroupProps {
  memeId: string;
  visibility: MemeVisibility | "public";
  onSuccess?: () => void;
  onCancel?: () => void;
}

export default function VisibilityGroup({
  memeId,
  visibility: initialVisiblity,
  onSuccess,
  onCancel
}: VisibilityGroupProps) {
  const [visibility, setVisibility] = useState<"public" | "private">(initialVisiblity || "public");
  const [loading, setLoading] = useState(false);

  const handleVisibilityChange = async () => {
    setLoading(true);
    const response = await fetchWithAuth(`/api/v2/meme/${memeId}/visibility`, {
      method: "PATCH",
      body: JSON.stringify({ visibility })
    });

    setLoading(false);

    if (response.ok) {
      if (onSuccess) {
        onSuccess();
      }
    } else {
      const error = await response.json();
      console.error("Failed to update visibility:", error);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        Change Visibility
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", alignSelf: "start", gap: "8px" }}>
        <Typography> Who can see this meme?</Typography>
        <RadioGroup row value={visibility} onChange={(e) => setVisibility(e.target.value as "public" | "private")}>
          <FormControlLabel value="public" control={<Radio />} label="Everyone" />
          <FormControlLabel value="private" control={<Radio />} label="Unlisted" />
        </RadioGroup>
        <Box
          sx={{
            padding: "12px",
            border: "1px solid #424242",
            borderRadius: 4,
            display: "flex"
          }}
        >
          <Typography variant="subtitle2" color="textDisabled" noWrap>
            {visibility === "public"
              ? "Memes in this thread can be seen in Gallery"
              : "Only you and people with the link can see it"}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "end", gap: "12px" }}>
          <Button onClick={onCancel} variant="texted">
            Cancel
          </Button>
          <Button variant="gradient" onClick={handleVisibilityChange} disabled={loading}>
            Confirm
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
